import React, { Component } from 'react';
import Form from '../../models/Form';
import FormCategory from '../../models/FormCategory';
import Language from '../../models/Language';

declare var dataLayer: any;

type FormListItemProps = {
    form: Form,
    categorySelected: (category: FormCategory) => void,
    languageSelected: (category: Language) => void,
    onlineLinkLabel: string,
    downloadAltLabel: string
}


export default class FormListItem extends Component<FormListItemProps> {
    constructor(props: FormListItemProps) {
        super(props);
    }

    public render() {
        return (
            <div className="d-flex flex-column flex-md-row p-2 bg-brown-10-alpha-hover align-items-left rounded">
                <div className="flex-grow-1 d-flex flex-column">
                    <div className="order-2 order-md-1 font-weight-bold">{this.props.form.title}</div>
                    <div className="order-1 order-md-2 text-primary text-medium">
                        <a href="#" onClick={() => { this.props.categorySelected(this.props.form.category) }}>{this.props.form.category.name}</a>,&nbsp;
                        <a href="#" onClick={() => { this.props.languageSelected(this.props.form.language) }}>{this.props.form.language.name}</a>
                    </div>
                </div>
                <div className="d-flex">
                    <div>
                        <a className={"mr-2 mr-md-0 btn btn-outline-primary" + (this.props.form.attachmentUrl !== '' ? "" : " d-none")} href={this.props.form.attachmentUrl} target="_blank">
                            <img src="/img/svg/icon-download-grey.svg" alt={this.props.downloadAltLabel + " " + this.props.form.title} />
                        </a>
                        <a className={"mr-2 mr-md-0 ml-0 ml-md-2 btn btn-outline-primary" + (this.props.form.videoUrl !== '' ? "" : " d-none")} href={this.props.form.videoUrl} target="_blank">
                            <img src="/img/svg/icon-film-grey.svg" className="icon-fixed-height" alt={"watch video " + this.props.form.title} />
                        </a>
                    </div>
                    <div>
                        <a className={"ml-0 ml-md-2 btn btn-outline-primary" + (this.props.form.url !== '' ? "" : " d-none")} href={this.props.form.url}>
                            {this.props.onlineLinkLabel}
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}